import { MessageBox } from 'element-ui'
import moment from 'moment'
import { previewOverlaps, PricingOverlap, PricingPreviewParams } from '@/api/pricings'

const ACTION_LABELS: Record<PricingOverlap['action'], string> = {
  close: 'sera clôturée à la date de début de la nouvelle période',
  trim_start: 'verra sa date de début décalée après la fin de la nouvelle période',
  delete: 'sera supprimée (entièrement recouverte par la nouvelle période)'
}

const formatDate = (value: string | null) => (value ? moment(value).format('L') : 'indéterminée')

const overlapLine = (overlap: PricingOverlap) =>
  `Période du ${formatDate(overlap.currentValidFrom)} au ${formatDate(overlap.currentValidTo)} : ` +
  `${ACTION_LABELS[overlap.action] || overlap.action}`

/**
 * Checks whether creating this pricing period would overlap existing ones and, if so, asks the
 * admin to confirm before proceeding. Returns true when it's safe to call `.save()` (no overlap,
 * or the admin confirmed), false when the admin cancelled.
 */
export async function confirmPricingOverlaps(params: PricingPreviewParams): Promise<boolean> {
  const { valid, overlaps } = await previewOverlaps(params)

  if (!valid || !overlaps.length) return true

  try {
    await MessageBox.confirm(
      overlaps.map(overlapLine).join('\n'),
      'Cette période chevauche des périodes existantes',
      {
        confirmButtonText: 'Confirmer',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }
    )
    return true
  } catch {
    return false
  }
}
